import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

import { getEditMode } from '@/lib/i18nOverrides/editMode';
import { stripMarkersDeep } from '@/lib/i18nOverrides/markers';

/** Removes edit-mode key markers from the request body and params, so a marked label never reaches the backend. */
export const stripRequestMarkers = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig =>
  getEditMode() ? { ...config, data: stripMarkersDeep(config.data), params: stripMarkersDeep(config.params) } : config;

/** Each axios instance has its own interceptor chain — attach to the global instance and to every created one. */
export const attachMarkerStripInterceptor = (instance: AxiosInstance): number =>
  instance.interceptors.request.use(stripRequestMarkers);
